export function safeSubtract(
  a: number,
  b: number
): number {
  // Vars
  const result = a - b

  return result < 0 ? 0 : result
}